import {observer} from 'mobx-react-lite'
import React from 'react'
import {
  rowHeight,
  useTimelineNewStore
} from '@components/timeline-new/timeline-new-store'
import {Svg} from './svg'

const centerToTop = 21
const leftToCenter = 4
const padding = 8

export const DragLinkLine = observer(() => {
  const [state, store] = useTimelineNewStore()

  if (!state.linkingHubId || !state.linkingPath) {
    return null
  }

  const data = state.itemDataRegistry[state.linkingHubId]
  if (!data?.deadline?.end) {
    return null
  }

  const fromTimestamp = store.endTimeToSnappedTime(data.deadline.end)
  const fromX = store.timeToPosition(fromTimestamp) + leftToCenter
  const fromY = state.linkingSwimlaneIx * rowHeight + centerToTop
  const toX = state.linkingPoint.x
  const toY = state.linkingPoint.y
  const width = Math.abs(toX - fromX) + 2 * padding
  const height = Math.abs(toY - fromY) + 2 * padding
  const left = Math.min(fromX, toX) - padding
  const top = Math.min(fromY, toY) - padding
  const x1 = fromX - left
  const y1 = fromY - top
  const x2 = toX - left
  const y2 = toY - top
  const transform = `translate(${left}px,${top}px)`

  return (
    <Svg
      height={height}
      width={width}
      className="absolute pointer-events-none z-1000"
      style={{transform}}
    >
      <circle cx={x1} cy={y1} r={1.5} className="fill-action-default" />
      <circle cx={x2} cy={y2} r={5} className="fill-action-default" />
      <line
        x1={x1}
        y1={y1}
        x2={x2}
        y2={y2}
        strokeWidth={1}
        className="stroke-action-default"
      />
      <circle cx={x2} cy={y2} r={3} className="fill-icon-invert" />
    </Svg>
  )
})
